import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import '@fortawesome/fontawesome-svg-core/styles.css'
import './index.css'
import { AuthProvider } from './contexts/AuthContext'
import { EnvironmentBanner } from './components/EnvironmentBanner'
import { AppRoutes } from './routes/AppRoutes'
import { legacyHashToPath } from './routes/legacyHash'

// Routing lives in routes/AppRoutes.tsx (react-router). Rewrite an old `/#/…`
// bookmark before the router starts, so it opens on the right page with no flash
// (<LegacyHashRedirect> also catches later in-app hash links).
const legacyPath = legacyHashToPath(window.location.hash)
if (legacyPath) window.history.replaceState(null, '', legacyPath)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <EnvironmentBanner />
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  </StrictMode>,
)
